import React from "react";
import { MapPin, Calendar, Flag } from "lucide-react";
import { Crescent, Ribbon } from "./Decor";
import { Countdown } from "./Countdown";
import { EVENT } from "../lib/data";

export const Hero = () => (
  <section className="relative sunburst overflow-hidden" data-testid="hero-section">
    <div className="absolute inset-0 sunburst-green pointer-events-none" />
    <div className="relative max-w-6xl mx-auto px-4 md:px-8 py-12 md:py-20">
      {/* Ornate double-border frame */}
      <div className="border-4 border-double border-gold p-2 md:p-3">
        <div className="border-2 border-forest px-4 md:px-10 py-10 md:py-16 text-center relative">
          {/* Winnipeg banner */}
          <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-forest text-gold-light eyebrow px-6 py-1.5 border border-gold whitespace-nowrap" data-testid="hero-topbanner">
            Winnipeg · 2026
          </div>

          <div className="flex justify-center mb-4 mt-2">
            <Crescent size={72} className="animate-fade-up" />
          </div>

          <h1 className="font-display font-black text-forest leading-[0.85] text-6xl sm:text-7xl md:text-8xl tracking-tight drop-shadow-[2px_2px_0_rgba(201,162,75,0.5)]" data-testid="hero-title">
            PAK FEST
            <span className="block text-rust text-7xl sm:text-8xl md:text-9xl">2026</span>
          </h1>

          <div className="flex justify-center my-6">
            <Ribbon>{EVENT.tagline}</Ribbon>
          </div>

          <div className="flex justify-center mb-7" data-testid="hero-independence">
            <span className="inline-flex items-center gap-2 border-2 border-rust bg-cream/70 text-rust eyebrow px-5 py-2 text-center leading-tight">
              <Flag size={16} className="shrink-0" /> Celebrating the 79th Independence Day of Pakistan
            </span>
          </div>

          <div className="flex flex-col sm:flex-row items-stretch justify-center gap-3 md:gap-4 max-w-2xl mx-auto mb-9" data-testid="hero-eventinfo">
            <div className="flex-1 border-2 border-forest bg-cream/80 px-5 py-4 flex items-center justify-center gap-3" data-testid="hero-datetime">
              <Calendar size={22} className="text-rust shrink-0" />
              <div className="text-left leading-tight">
                <div className="font-display font-bold text-forest text-lg md:text-xl">{EVENT.dateLabel}</div>
                <div className="numeral text-rust text-base md:text-lg tracking-wide">{EVENT.timeLabel}</div>
              </div>
            </div>
            <div className="flex-1 border-2 border-forest bg-cream/80 px-5 py-4 flex items-center justify-center gap-3" data-testid="hero-venue">
              <MapPin size={22} className="text-rust shrink-0" />
              <div className="text-left leading-tight">
                <div className="font-display font-bold text-forest text-lg md:text-xl">{EVENT.venue}</div>
                <div className="font-mono text-forest-light text-xs md:text-sm">{EVENT.address}</div>
              </div>
            </div>
          </div>

          <div className="mb-9">
            <p className="eyebrow text-forest-light mb-4">The Countdown Begins</p>
            <Countdown />
          </div>

          <div className="grid grid-cols-2 sm:flex sm:flex-wrap items-stretch justify-center gap-3 md:gap-4 max-w-3xl mx-auto">
            <a href="#join-sponsor" className="btn-rust px-5 py-4 text-xs md:text-sm flex items-center justify-center whitespace-nowrap" data-testid="hero-sponsor-btn">
              Become a Sponsor
            </a>
            <a href="#join-vendor" className="btn-rust px-5 py-4 text-xs md:text-sm flex items-center justify-center whitespace-nowrap" data-testid="hero-vendor-btn">
              Become a Vendor
            </a>
            <a href="#join-talent" className="btn-forest px-5 py-4 text-xs md:text-sm flex items-center justify-center whitespace-nowrap" data-testid="hero-talent-btn">
              Perform
            </a>
            <a href="#join-volunteer" className="btn-forest px-5 py-4 text-xs md:text-sm flex items-center justify-center whitespace-nowrap" data-testid="hero-volunteer-btn">
              Volunteer
            </a>
            <a href="#join-updates" className="btn-ghost px-5 py-4 text-xs md:text-sm flex items-center justify-center whitespace-nowrap" data-testid="hero-updates-btn">
              Stay Updated
            </a>
          </div>
        </div>
      </div>
    </div>
  </section>
);
